<template>
  <div>
    <div class="logo"></div>
    <div class="workshopTitle" v-if="workshopData"><span v-if="workshopData != undefined && workshopData.companyName != undefined">Company {{workshopData.companyName}} ⁃ </span><span>Workshop {{workshopData.name}}</span></div>
    <workshop-chart :class="{hidden:step !== 1}"  @stopVote="showPotentialTable"></workshop-chart>
    <workshop-topic-selection v-if="step == 2" @next="showResultTable" @back="showChart"></workshop-topic-selection>
    <result-table v-if="step == 3" :selection="selection" @next="showTaskView"  @back="showPotentialTable"></result-table>
    <TaskView v-if="step == 4"></TaskView>
<!--    <jira-tasks></jira-tasks>-->
  </div>
</template>

<script>
import WorkshopChart from "@/components/workshopChart.vue";
import WorkshopTopicSelection from "@/components/workshopTopicSelection.vue";
import ResultTable from "@/components/resultTable.vue";
import {loadWorkshop} from "@/workshop/workshopFunctions";
import TaskView from "@/views/TaskView.vue";
export default {
  name: "workshopView",
  components: {TaskView, ResultTable, WorkshopTopicSelection, WorkshopChart },
  data() {
    return {
      step: 1,
      selection: [],
      workshopData: {},
    }
  },
  computed: {
    customerId() {
      return this.$route.params.customerId;
    },
    workshopId() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.$store.dispatch('saveCustomerId', this.customerId);
    loadWorkshop(this.customerId, this.workshopId).then(res => {
      this.workshopData = res;
    });
  },
  methods: {
    showPotentialTable(){
      this.step = 2;
    },
    showResultTable(selection){
      this.step = 3;
      this.selection = selection;
    },
    showTaskView(){
      this.step = 4;
    },
    showChart(){
      this.step = 1;
    }
  }
}
</script>

<style>
  .workshopTitle{
    font-size: 26px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
  }
  .logo {
    position: absolute;
    top: 0;
    left: 0;
    width: 300px;
    height: 150px;
    background-image: url('../assets/Logo_Text.png');
    background-repeat: no-repeat;
    background-size: contain;
  }
  .hidden {
    display: none;
  }
</style>